import { render, staticRenderFns } from "./ConvocationPaymentPage.vue?vue&type=template&id=338fcce6"
import script from "./ConvocationPaymentPage.vue?vue&type=script&lang=js"
export * from "./ConvocationPaymentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports